import { PartialNullable } from "../Extensions";
import { ArrayHelper } from "../Helpers/ArrayHelper";
import { PropertyChange } from "../PropertyChange";
import { Property } from "../RadObject";
import { Expression, ExpressionPropertyValues, IExpression } from "./Expression";
import { NAMESPACE } from "./_Namespace";

export type ListOfExpressionPropertyValues =
    ExpressionPropertyValues
    & {
        expressions: (Expression | string)[];
    };

export type ListOfExpressionProperties = {
    [name in keyof ListOfExpressionPropertyValues]: Property<ListOfExpressionPropertyValues[name]>
};

export interface IListOfExpression extends IExpression, ListOfExpressionProperties
{
}

export abstract class ListOfExpression<TPropertyValues extends ListOfExpressionPropertyValues = ListOfExpressionPropertyValues> extends Expression<TPropertyValues> implements IListOfExpression
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ListOfExpression";
    public static override className = "ListOfExpression";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ListOfExpressionPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                expressions: [],
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public expressions!: Property<(Expression | string)[]>;

    // #endregion

    // #region Public Methods

    public add(expression: Expression | string)
    {
        const
            expressions = this.expressions.get();

        if (!expressions)
            return;

        expressions.push(expression);
    }
    public count()
    {
        const
            expressions = this.expressions.get();

        return expressions?.length ?? 0;
    }
    public remove(expression: Expression | string)
    {
        const
            expressions = this.expressions.get();

        if (!expressions)
            return;

        ArrayHelper.remove(expressions, expression);
    }

    // #endregion

    // #region Protected Methods

    protected _expressionsChanged(change: PropertyChange<(Expression | string)[]>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: TPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.expressions = new Property<(Expression | string)[]>(this, "System.Object, System.Private.CoreLib", propertyValues.expressions, this._expressionsChanged);
    }

    // #endregion

    // #endregion
}